import type { HTMLAttributes, ReactNode } from "react";

// `title` is widened to ReactNode, so the native string-only attribute is dropped.
export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  /** `panel` is the sidebar/section treatment, `sunken` the darker form container. */
  variant?: "default" | "panel" | "sunken";
  title?: ReactNode;
  /** Emoji glyph shown before the title. */
  icon?: string;
  children?: ReactNode;
}

const VARIANT_CLASS = {
  default: "",
  panel: "z-card--panel",
  sunken: "z-card--sunken",
} as const;

export function Card({
  variant = "default",
  title,
  icon,
  className,
  children,
  ...rest
}: CardProps) {
  const classes = ["z-card", VARIANT_CLASS[variant], className ?? ""]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} {...rest}>
      {title ? (
        <h3 className="z-card__title">
          {icon ? (
            <i className="z-icon" aria-hidden="true">
              {icon}
            </i>
          ) : null}
          {title}
        </h3>
      ) : null}
      {children}
    </div>
  );
}
